import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.updateIcon()
  }

  toggle() {
    const current = document.documentElement.dataset.theme
    const next = current === "dark" ? "light" : "dark"
    document.documentElement.dataset.theme = next
    document.cookie = `theme=${next};path=/;max-age=${365 * 24 * 60 * 60};SameSite=Lax`
    this.updateIcon()
  }

  updateIcon() {
    const isDark = document.documentElement.dataset.theme === "dark"
    this.iconTarget.className = "fa-solid fa-circle-half-stroke"
  }
}
